<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardHeader>
          <strong>Το προφίλ μου:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit User id:  {{ $route.params.id }}
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput type="text" label="Ονοματεπώνυμο" addLabelClasses="requiredLabel" id="company" placeholder="Ονοματεπώνυμο" v-model="name" horizontal></CInput>
              <CInput type="text" label="E-mail" addLabelClasses="requiredLabel" id="email" placeholder="E-mail" v-model="email" horizontal></CInput>
              <CInput type="text" label="Διεύθυνση" addLabelClasses="requiredLabel" id="address" placeholder="Διεύθυνση" v-model="address" horizontal></CInput>
              <CSelect horizontal label="Κατάσταση" addLabelClasses="requiredLabel" id="status" :value.sync="status" :options="[{ value: 'Active', label: 'Active' }, { value: 'Inactive', label: 'Inactive' }, { value: 'Pending', label: 'Pending' }, { value: 'Banned', label: 'Banned' }]" />
              <label class="requiredLabel">Ρόλοι</label>
              <multiselect 
                v-model="roles"
                :value.sync="roles" 
                :options="multiselectOptions" 
                :close-on-select="false"
                id="roles"
                name="roles[]"
                class="mb-3"
                placeholder="Ρόλοι"
                multiple
              ></multiselect>
            <CButton v-if="this.$route.params.id == this.you" color="primary" @click="update()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardHeader>
          <strong>Κωδικός πρόσβασης</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit User id:  {{ $route.params.id }}
            </template>
              <CInput type="password" label="Κωδικός πρόσβασης" id="password" placeholder="Κωδικός πρόσβασης" v-model="password" horizontal @input="fill_password($event)"></CInput>
              <CInput type="password" label="Επαλήθευση κωδικού" id="repeat_password" placeholder="Επαλήθευση κωδικού" v-model="repeat_password" horizontal @input="fill_repeat_password($event)"></CInput>
            <CButton v-if="(this.$route.params.id == this.you && (check_pwd == check_repeat_pwd) && (check_pwd != '' && check_repeat_pwd != ''))" color="primary" @click="updatePassword()">Αποθήκευση</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'EditProfile',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  components: {
    Multiselect,
  },
  data: () => {
    return {
        multiselectOptions: ["admin", "user", "invoice_user"],
        title: '',
        name: '',
        email: '',
        address: '',
        password: '',
        repeat_password: '',
        check_pwd: '',
        check_repeat_pwd: '',
        roles: [],
        status: '',
        you: null,
        alertIsShown: false,
        showMessage: false,
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    fill_password (val) {
      this.check_pwd = val;
    },
    fill_repeat_password (val) {
      this.check_repeat_pwd = val;
    },
    updatePassword() {
        let self = this;
        axios.post('/api/profile/updatePassword/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'POST',
            password: self.password,
        })
        .then(function (response) {
            self.message = 'Επιτυχής ενημέρωση του κωδικού πρόσβασης.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    update() {
        let self = this;
        axios.post('/api/profile/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            name: self.name,
            email: self.email,
            address: self.address,
            password: self.password,
            roles: JSON.stringify(self.roles).replace(/]|[[""]/g, ''),
            status: self.status,
        })
        .then(function (response) {
            self.message = 'Επιτυχής ενημέρωση του προφίλ σας.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/profile/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        self.you = response.data.you;

        if (self.$route.params.id != self.you) {
          self.$router.push({path: `/profile/${self.you}/edit`});
          location.reload();
        } else {
          self.name = response.data.user.name;
          self.email = response.data.user.email;
          self.address = response.data.user.address;
          self.roles = JSON.stringify(response.data.user.roles).replace(/]|[[""]/g, '').split(',');
          self.status = response.data.user.status;

          const ser_items = Object.entries(response.data.user).map(([key, value]) => {return {key: key, value: value}});
          const keys = ["name", "email"];
          self.items = ser_items.filter((t) => keys.includes(t.key));
          self.title = self.items.find((t) => t.key == "name").value;
        }
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}


</script>
